import { createVuetify } from 'vuetify'
// import * as components from 'vuetify/components'
// import * as directives from 'vuetify/directives'
// import 'vuetify/lib/styles/main.sass'

export default defineNuxtPlugin((nuxtApp) => {
	const vuetify = createVuetify({
		// components,
		// directives,
		theme: {
			defaultTheme: 'light',
		},
		// props every instance in the app uses — set once here instead of on each component
		defaults: {
			VTextarea: { variant: 'solo' },
			VTable: { density: 'compact' },
			VProgressCircular: { indeterminate: true },
		},
		ssr: true,
	})

	nuxtApp.vueApp.use(vuetify)
})
